import React, { useState } from "react";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { Breadcrumb, ConfigProvider, Flex, Tabs } from "antd";
import { useSelector } from "react-redux";

import AdminRolePage from "../pages/AdminRole";
import AdminPermissionPage from "../pages/AdminPermission";
import AdminList from "../pages/AdminList";

const AdminSetting = () => {
  const { t } = useTranslation();
  const [selectedMenu, setSelectedMenu] = useState("admin_list");

  const menuBreadcrumbMapping = {
    admin_list: t("admin_setting.label.admin_permission"),
    admin_userRole: t("role.header"),
    admin_permission: t("permission.header"),
  };

  const handleTabChange = (key) => setSelectedMenu(key);

  return (
    <MainLayout>
      <Flex vertical gap={24}>
        <Flex vertical>
          <Breadcrumb
            items={[
              { title: t("configuration.header"), href: "/admin/response_company" },
              { title: t("admin_setting.header"), href: "" },
              { title: menuBreadcrumbMapping[selectedMenu] },
            ]}
          />

          <h2>
            {menuBreadcrumbMapping[selectedMenu] || t("admin_setting.header")}
          </h2>
        </Flex>

        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "var(--tab-color)",
                itemActiveColor: "var(--tab-color)",
              },
            },
          }}
        >
          <Tabs
            destroyInactiveTabPane
            defaultActiveKey="admin_list"
            onChange={handleTabChange}
          >
            <Tabs.TabPane
              tab={t("admin_setting.label.admin_permission")}
              key="admin_list"
            >
              <AdminList />
            </Tabs.TabPane>

            <Tabs.TabPane tab={t("role.header")} key="admin_userRole">
              <AdminRolePage />
            </Tabs.TabPane>

            <Tabs.TabPane tab={t("permission.header")} key="admin_permission">
              <AdminPermissionPage />
            </Tabs.TabPane>
          </Tabs>
        </ConfigProvider>
      </Flex>
    </MainLayout>
  );
};

export default AdminSetting;

